// src/contexts/pedidos/TipoEntregaContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const TipoEntregaContext = createContext();

export const useTipoEntrega = () => useContext(TipoEntregaContext);

export const TipoEntregaProvider = ({ children }) => {
    const [tiposEntrega, setTiposEntrega] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/TipoEntrega');
                setTiposEntrega(result);
            } catch (error) {
                console.error('Erro ao buscar tipos de entrega:', error);
                showMessage('Erro ao buscar tipos de entrega!\n' + error, 'danger');
            }
        };

        fetchDataFromAPI();
    }, []);

    const addTipoEntrega = async (tipoEntrega) => {
        try {
            const result = await postData('/TipoEntrega', tipoEntrega);
            setTiposEntrega([...tiposEntrega, result]);
            showAlert('Tipo de entrega adicionado com sucesso!');
        } catch (error) {
            console.error('Erro ao adicionar tipo de entrega:', error);
            showMessage('Erro ao adicionar tipo de entrega!\n' + error, 'danger');
        }
    };

    const updateTipoEntrega = async (tipoEntrega) => {
        try {
            const result = await putData('/TipoEntrega', tipoEntrega);
            setTiposEntrega(tiposEntrega.map(t => t.id === result.id ? result : t));
            showAlert('Tipo de entrega alterado com sucesso!');
        } catch (error) {
            console.error('Erro ao atualizar tipo de entrega:', error);
            showMessage('Erro ao atualizar tipo de entrega!\n' + error, 'danger');
        }
    };

    const deleteTipoEntrega = async (id) => {
        try {
            await deleteData('/TipoEntrega', { tipoEntregaId: id });
            setTiposEntrega(tiposEntrega.filter(t => t.id !== id));
            showAlert('Tipo de entrega excluído com sucesso!');
        } catch (error) {
            console.error('Erro ao excluir tipo de entrega:', error);
            showMessage('Erro ao excluir tipo de entrega!\n' + error, 'danger');
        }
    };

    return (
        <TipoEntregaContext.Provider value={{ tiposEntrega, addTipoEntrega, updateTipoEntrega, deleteTipoEntrega }}>
            {children}
        </TipoEntregaContext.Provider>
    );
};
